import type { Locale } from "../../../shared/I18n";

export function normalizeViewJobUrl(url: string | null, locale: Locale): string | null {
  if (!url) {
    return null;
  }
  try {
    const urlObj = new URL(url);

    // Check if hostname is missing subdomain (e.g., "indeed.com")
    const indeedDomainPattern = /^indeed\.(.+)$/i;
    const match = urlObj.hostname.match(indeedDomainPattern);
    if (!match) {
      // URL already has subdomain or is not an Indeed URL
      return url;
    }

    // Preserve original TLD when replacing with locale-specific host
    const originalTld = match[1];
    const countrySubdomain =
      locale.country === "US" || locale.country === null ? "www" : locale.country.toLowerCase();
    urlObj.hostname = `${countrySubdomain}.indeed.${originalTld}`;

    return urlObj.toString();
  } catch (error) {
    console.error("Failed to normalize ViewJob URL:", error);
    return url; // Return original URL if parsing fails
  }
}
